import { render, staticRenderFns } from "./dynamics.vue?vue&type=template&id=978c17f4&scoped=true"
import script from "./dynamics.vue?vue&type=script&lang=js"
export * from "./dynamics.vue?vue&type=script&lang=js"
import style0 from "./dynamics.vue?vue&type=style&index=0&id=978c17f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978c17f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('978c17f4')) {
      api.createRecord('978c17f4', component.options)
    } else {
      api.reload('978c17f4', component.options)
    }
    module.hot.accept("./dynamics.vue?vue&type=template&id=978c17f4&scoped=true", function () {
      api.rerender('978c17f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/program/programList/dynamics.vue"
export default component.exports